<template>

   <b-modal
      id="modal-practice-add"
      centered
      title="Aggiungi Tipologia Pratica"
      title-class="text-primary-light"
      header-text-variant="primary-light"
      body-class="px-0"
      size="md"
      ok-only
      ok-title="Aggiungi"
      @ok="addPractice"
      @hide="$emit('hide', $event)"
    >

        <template #default>
        
        <div class="p-2">
            <b-form-group label="Nome Tipologia Pratica">
                <b-form-input v-model="practices_name"></b-form-input>
            </b-form-group>
        </div>

        </template>

    </b-modal>
    
</template>

<script>

import {BRow, BCol, BModal, BImg, BFormInput, BFormGroup } from 'bootstrap-vue';

import {Requests} from "@/api";

export default {

    components: {
        BRow,
        BCol,
        BModal,
        BImg,
        BFormInput,
        BFormGroup,
    },

    data: () => ({
        practices_name: '',
    }),

    methods: {
        open() {
            this.$bvModal.show('modal-practice-add');
        },

        async addPractice() {
            this.loading = true;

            let request_data = new FormData();

            request_data.append('pratices_name', this.practices_name);

            try {
                const response = await Requests.addPractice(request_data);
                console.debug(response);
                this.$swal.fire({
                    title: 'Tipologia Pratica Creata',
                    icon: 'success',
                    text: 'Tipologia Pratica creata con successo!',
                    customClass: {
                        title: 'text-primary-light',
                        confirmButton: "btn btn-primary"
                    },
                })
            } catch(err) {
                console.debug(err);
            }

            this.loading = false;
        }
    }

}

</script>
